import { render, staticRenderFns } from "./JoineryColorSelection.vue?vue&type=template&id=cb103b98&scoped=true&"
import script from "./JoineryColorSelection.vue?vue&type=script&lang=js&"
export * from "./JoineryColorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb103b98",
  null
  
)

export default component.exports